const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHondaAuto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "69px",
    height: "72px",
    viewBox: "0 0 69 72",
    style: {
      enableBackground: "new 0 0 69 72"
    },
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Honda") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer_Large_1400px",
    transform: "translate(-631.000000, -588.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top_lockup",
    transform: "translate(32.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(599.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M47.7,55.2h-2.3v-4.3h2.3c1.4,0,1.8,0.6,1.8,2.2 C49.6,54.5,49.1,55.2,47.7,55.2 M48.2,49.5h-7v0.9l0.9,0.1c0.3,0.1,0.5,0.1,0.5,0.6v3.8c0,0.2-0.1,0.6-0.5,0.6l-0.9,0.1v0.9h7 c2.5,0,4.6-1,4.6-3.5S50.8,49.5,48.2,49.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A",
    transform: "translate(106.882353, 72.537313)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-6",
    style: {
      fill: "none"
    },
    points: "-40.1,-16.1 -40.1,-23.1 -54.5,-23.1 -54.5,-16.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-49.6-19.4l1.4-2.1l1.6,2.1H-49.6z M-41-17.1 c-0.5-0.1-0.6-0.4-0.8-0.6l-3.5-5c-0.3-0.4-0.4-0.5-0.8-0.5h-5.8v0.9l1.3,0.1c0.2,0,0.5,0.3,0.2,0.6l-2.6,3.9 c-0.1,0.1-0.2,0.4-0.6,0.4l-1.1,0.1v0.9h4.9v-0.9l-0.9-0.1c-0.4,0-0.6-0.3-0.4-0.6l0.4-0.6h4.7l0.4,0.5 c0.3,0.4-0.1,0.6-0.4,0.6l-0.9,0.1v0.9h6.6v-0.9L-41-17.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M35.2,50.4l1,0.1c0.4,0.1,0.5,0.4,0.5,0.6v3.5l-3.9-4.9 c-0.1-0.2-0.4-0.3-0.7-0.3h-5v0.9l1,0.1c0.4,0.1,0.5,0.4,0.5,0.6V55c0,0.2-0.1,0.6-0.5,0.6l-1,0.1v0.9h4.7v-0.9l-1-0.1 c-0.4-0.1-0.5-0.4-0.5-0.6v-3.5l3.9,4.9c0.1,0.2,0.4,0.3,0.7,0.3h0.1h3.5v-5.3c0-0.2,0.1-0.6,0.5-0.6l1-0.1v-0.9h-4.7L35.2,50.4 L35.2,50.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "O",
    transform: "translate(28.411765, 71.194030)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-11",
    style: {
      fill: "none"
    },
    points: "-2.1,-14 -13.6,-14 -13.6,-22.1 -2.1,-22.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-7.9-15.5c-1.8,0-2.6-0.8-2.6-2.6c0-1.8,0.7-2.6,2.6-2.6 c1.8,0,2.6,0.8,2.6,2.6C-5.3-16.3-6.1-15.5-7.9-15.5 M-7.9-22.1c-4.6,0-5.8,2.2-5.8,4c0,1.9,1.2,4,5.8,4s5.8-2.2,5.8-4 C-2.1-20-3.3-22.1-7.9-22.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M8.7,50.4l1,0.1c0.4,0.1,0.5,0.4,0.5,0.6v1.1H5.7v-1.1 c0-0.2,0.1-0.6,0.5-0.6l1-0.1v-0.9h-6v0.9l1,0.1c0.4,0.1,0.5,0.4,0.5,0.6v3.7c0,0.2-0.1,0.6-0.5,0.6l-1,0.1v0.9h6v-0.9l-1-0.1 c-0.4-0.1-0.5-0.4-0.5-0.6v-1.1h4.6v1.1c0,0.2-0.1,0.6-0.5,0.6l-1,0.1v0.9h6v-0.9l-1-0.1c-0.4-0.1-0.5-0.4-0.5-0.6v-3.7 c0-0.2,0.1-0.6,0.5-0.6l1-0.1v-0.9h-6L8.7,50.4L8.7,50.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "emblem",
    transform: "translate(32.470588, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M10.1,17.5c-0.9,3.6-1.1,5.3-1.8,8c-0.6,2.6-1.1,4.9-2,6 c-0.9,1.1-2,1.4-2.8,1.5C3.1,33,2.8,33,1.9,33s-1.2,0-1.6-0.1c-0.8-0.1-1.9-0.4-2.8-1.5c-0.9-1.1-1.3-3.5-2-6 c-0.6-2.6-1-4.3-1.8-8c0,0-0.8,0-1.2,0.1c-0.5,0-0.9,0-1.3,0.1c0,0,0.5,7.5,0.7,10.6c0.2,3.3,0.6,8.9,1,13.2 c0,0,0.7,0.1,1.8,0.1c1.1,0.1,1.7,0.2,1.7,0.2c0.5-1.8,1.1-4.5,1.8-5.6c0.6-0.9,1.4-1,1.9-1.1C1,35.1,1.7,35,1.9,35l0,0l0,0 c0.3,0,0.9,0,1.7,0.1c0.5,0.1,1.3,0.1,1.9,1.1c0.7,1.1,1.3,3.7,1.8,5.6c0,0,0.5,0,1.7-0.1c1.1-0.1,1.8-0.1,1.8-0.1 c0.4-4.3,0.8-9.9,1-13.2c0.2-3.2,0.7-10.6,0.7-10.6c-0.4-0.1-0.8-0.1-1.3-0.1C11,17.5,10.1,17.5,10.1,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M17.6,30.3c-0.3,3.9-0.6,6.3-1.1,8 c-0.4,1.5-0.9,2.5-1.7,3.2c-1.3,1.2-3.1,1.5-4,1.6c-2.2,0.4-6,0.5-8.9,0.5s-6.7-0.1-8.9-0.5c-1-0.1-2.8-0.4-4-1.6 c-0.8-0.7-1.3-1.7-1.7-3.2c-0.5-1.7-0.8-4-1.1-8c-0.1-2.3-0.1-6.2,0.1-8.3c0.4-3.1,1.8-4.6,5-5.2c1.3-0.3,3.3-0.5,5.2-0.6 c1.5-0.1,4-0.1,5.3-0.1s3.8,0.1,5.3,0.1c1.8,0.1,3.8,0.3,5.3,0.6c3.1,0.6,4.6,2.1,5,5.2C17.6,24.1,17.7,27.9,17.6,30.3  M19.3,22c-0.5-4.9-3.6-6-6.4-6.5c-1.4-0.2-3.8-0.4-5.5-0.5c-1.3-0.1-4.6-0.2-5.6-0.2s-4.3,0.1-5.6,0.1c-1.6,0.1-4,0.3-5.5,0.6 c-2.8,0.5-5.9,1.5-6.4,6.5c-0.1,1.3-0.1,3.1-0.1,5c0.1,3.1,0.3,5.3,0.4,6.7c0.1,1,0.5,4,1,5.5c0.7,2.1,1.3,2.8,2.1,3.4 c1.3,1.1,3.6,1.5,4.1,1.6c2.6,0.5,7.7,0.6,9.9,0.6s7.4-0.1,9.9-0.6c0.5-0.1,2.7-0.4,4.1-1.6c0.8-0.6,1.3-1.3,2.1-3.4 c0.5-1.6,0.9-4.5,1-5.5c0.1-1.5,0.4-3.5,0.4-6.7C19.4,25.1,19.4,23.4,19.3,22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHondaAuto);
export default __webpack_public_path__ + "static/media/honda_auto.98c470981c5028dd229e4077fc0d7ee8.svg";
export { ForwardRef as ReactComponent };